import { createAction } from 'typesafe-actions';

import { LegFlow } from '../../../../../../models/LegFlow';

export type UpdateFlowTableByCellEditPayload = {
  legNumber: number;
  rowId: number;
  row: LegFlow;
};
export const updateFlowTableByCellEdit = createAction(
  'pricer/flows/updateFlowTableByCellEdit',
)<UpdateFlowTableByCellEditPayload>();

export type DeleteFlowRowsPayload = {
  legNumber: number;
  rowIds: number[];
};
export const deleteFlowRows = createAction(
  'pricer/flows/deleteFlowRows',
)<DeleteFlowRowsPayload>();
